import { GET_ALL_LOGIN_DETAILS } from "./ActionTypes";

export const getAllLoginData = (payload) => ({

    type: GET_ALL_LOGIN_DETAILS,
    payload,

});